<template>
    <div class="text-nowrap">
        {{ text }}
        <a v-if="ordering !== ascParam && ordering !== descParam" :href="generateUrl('order', ascParam)" title="Sort in ascending order">
            <i class="fa fa-sort" aria-hidden="true" />
        </a>
        <a v-else-if="ordering === descParam" :href="generateUrl('order', ascParam)" title="Sort in ascending order">
            <i class="fa fa-sort-asc" aria-hidden="true" />
        </a>
        <a v-else-if="ordering === ascParam" :href="generateUrl('order', descParam)" title="Sort in descending order">
            <i class="fa fa-sort-desc" aria-hidden="true" />
        </a>
    </div>
</template>

<script>
import urlManipulator from 'src/mixins/url-manipulator.js'
export default {
    name: "SortingArrows",
    mixins: [urlManipulator],
    props: {
        text: {
            type: String,
            required: true,
        },
        ordering: {
            type: String,
            required: true,
        },
        ascParam: {
            type: String,
            required: true,
        },
        descParam: {
            type: String,
            required: true,
        },
    }
}
</script>

<style scoped>

</style>
